import { useNavigate } from "react-router-dom";
import { useActiveAccount } from "@/hooks/useAccounts";
import { useConnectionStatus } from "@/hooks/useConnectionStatus";
import { GlobalClock } from "@/components/GlobalClock";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

export function ActiveAccountCard() {
  const navigate = useNavigate();
  const { data: account } = useActiveAccount();
  const { status } = useConnectionStatus(account?.id ?? "");
  const { language } = useLanguage();
  const fa = language === "fa";

  if (!account) {
    return (
      <button
        onClick={() => navigate("/account/trading")}
        className="hidden lg:flex items-center px-3 py-2 rounded-md border border-dashed border-border bg-muted/30 text-xs text-muted-foreground hover:bg-muted transition-colors min-w-[200px] justify-center"
      >
        {fa ? "اتصال به بروکر" : "Connect to Broker"}
      </button>
    );
  }

  const isConnected = status === "connected";
  const displayName = account.nickname || account.account_login;

  return (
    <button
      onClick={() => navigate("/account/trading")}
      className="hidden lg:flex flex-col gap-0 px-2.5 py-1 rounded-md border border-primary/30 bg-primary/10 hover:bg-primary/15 transition-colors min-w-[180px] text-left text-[11px]"
    >
      {/* Row 1: displayName + platform badge */}
      <div className="flex items-center justify-between gap-1 w-full">
        <span className="font-medium truncate text-foreground">{displayName}</span>
        <Badge variant="outline" className="text-[9px] px-1 py-0 shrink-0">
          {account.platform}
        </Badge>
      </div>
      {/* Row 2: broker_server */}
      <div className="text-muted-foreground truncate w-full">
        {account.broker_server}
      </div>
      {/* Row 3: Active + connection status */}
      <div className="flex items-center justify-between w-full mt-0.5">
        <span className="text-[10px] font-medium text-primary">
          {fa ? "فعال" : "Active"}
        </span>
        <span className={cn(
          "flex items-center gap-1 text-[10px]",
          isConnected ? "text-emerald-500" : "text-muted-foreground"
        )}>
          <span className={cn(
            "w-1.5 h-1.5 rounded-full inline-block",
            isConnected ? "bg-emerald-500" : "bg-destructive"
          )} />
          {isConnected ? (fa ? "متصل" : "Connected") : (fa ? "قطع" : "Disconnected")}
        </span>
      </div>
    </button>
  );
}

export const TopBarAccountCluster = () => {
  return (
    <div className="flex items-center gap-3">
      <GlobalClock />
      <ActiveAccountCard />
    </div>
  );
};
